import { createContext } from 'react';
import { DropzoneDelete, DropzoneUpload } from 'models/Dropzone';
import { DropzoneFile } from 'components/Dropzone/utils';
import utils from 'utils';

type DropzoneRequestsContextProps = {
  files: Array<DropzoneFile>;
  updateFiles: (newFiles: DropzoneFile[]) => void;
  uploadRequest: DropzoneUpload;
  deleteRequest: DropzoneDelete;
};

export default createContext<DropzoneRequestsContextProps>({
  files: [],
  uploadRequest: utils.noop,
  deleteRequest: utils.noop,
  updateFiles: utils.noop,
});
